<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-users text-primary mr-2"></i>
                    Gestión de Tipos de Respuesta de Consulta
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getQueryAnswerTypesFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="QueryAnswerTypeTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="queryAnswerTypes"
                    :options="options"
                    :theme="theme">

                    <template v-if="mixinCheckPermission('QUERY_ANSWER_TYPE_EDIT')" slot="uuid" slot-scope="props">

                        <router-link :to="{ path: '/queries/answer-types/edit/'+props.row.uuid }">
                            <i class="fa fa-pencil"></i>
                        </router-link>

                    </template>

                    <template slot="categories" slot-scope="props">
                        <div v-for="category in props.row.categories">{{category.name}}</div>
                    </template>

                    <template slot="active" slot-scope="props">
                        <template v-if="props.row.active">Si</template>
                        <template v-else>No</template>
                    </template>

                </v-client-table>

            </b-card>
        </b-row>

    </div>
</template>

<script>

    import Vue from 'vue';
    import form from '@/helpers/form';
    import {ClientTable} from 'vue-tables-2';
    import ExportActions from '@/components/ExportActions';
    import {getQueryAnswerTypes} from '@/api/query-answer-type-api';

    Vue.use(ClientTable);

    export default {
        name: 'list-query-answer-types',
        components: {
            ExportActions
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nueva Respuesta',
                        path: '/queries/answer-types/add',
                        brand: 'fa fa-home'
                    },
                ],
                columns: ['uuid', 'query', 'answer', 'categories', 'active'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        query: 'Consulta',
                        answer: 'Respuesta',
                        categories: 'Categorías',
                        active: 'Activo',

                    },
                    columnsClasses: {
                        uuid: "fit"
                    },
                    sortable: ['query', 'answer', 'categories', 'active'],
                    filterable: ['query', 'answer'],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                queryAnswerTypes: [],
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQueryAnswerTypes();
        },
        methods: {

            async getQueryAnswerTypes() {

                this.$_loadingMixin_showLoading();

                await getQueryAnswerTypes()
                    .then((queryAnswerTypes) => {
                        this.queryAnswerTypes = queryAnswerTypes;
                    });

                this.$_loadingMixin_hideLoading();
            },

            getQueryAnswerTypesFilteredData() {
                if (!!this.$refs.QueryAnswerTypeTable) {
                    return this.$refs.QueryAnswerTypeTable.allFilteredData.map(queryAnswerType => ({
                        'ID': queryAnswerType.uuid,
                        'Consulta': queryAnswerType.query,
                        'Respuesta': queryAnswerType.answer,
                        'Creada por': queryAnswerType.createdBy,
                        'Creación': new Date(queryAnswerType.createdAt).toLocaleDateString(),
                        'Actualizada por': queryAnswerType.updatedBy,
                        'Actualización': new Date(queryAnswerType.updatedAt).toLocaleDateString(),
                        'Activo': queryAnswerType.active ? "Si" : "No",
                    }));
                } else {
                    return [];
                }
            },
        }
    }
</script>